module.exports = __webpack_public_path__ + "img/softIndicators.c16fc625.png";